/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 分析概览弹出框
 */
import styles from './overviewModal.scss';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Modal, Spin } from 'antd';
import GroupBox from '../../../common/groupBox/GroupBox';
import BBDRadar from '../../../common/echarts/BBDRadar';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import NoData from '../../../common/noData/NoData';
import { numberFixed, fieldAnomaly } from '../../../../utils/formatter';
import { createScoreRadarOption } from '../../../../utils/chart';
import { isNotEmpty, getChildOptions } from '../../../../utils/util';
import { statisticReportSummary, statisticReportTrend } from '../../../../services/regulatoryStatistical';
import {formatComTrendOption} from '../common/formatEchartOption';
import SearchForm from './overviewModal/SearchForm';
import BaseInfo from './overviewModal/BaseInfo';

export default class OverviewModal extends PureComponent {
    constructor(props) {
        super(props);
        this.trendData = [];
        this.state = {
            searchParams: {},
            scoreLoading: true,
            trendLoading: true,
            subAnaType: [],
            selectedSubAnaType: {},
            compositeScore: null,
            radarOption: {},
            lineOption: {}
        };
    }

    onSearch = (searchParams) => {
        const subAnaType = getChildOptions(searchParams.anaType, this.props.options && this.props.options.riskFakeTypes);
        const selectedSubAnaType = subAnaType[0] || {};
        this.setState({
            searchParams,
            subAnaType,
            selectedSubAnaType
        }, () => {
            this.getScore();
            this.getTrend();
        });
    };

    // 雷达图
    getScore = () => {
        let { item } = this.props;
        let { searchParams } = this.state;

        this.setState({
            scoreLoading: true
        });
        statisticReportSummary({ ...searchParams, companyCode: item.companyCode }).then(data => {
            data = data || {};
            this.setState({
                radarOption: createScoreRadarOption(data.radarData),
                compositeScore: numberFixed(data.tScore, null)
            });
        }).finally(() => {
            this.setState({
                scoreLoading: false
            });
        });
    };

    // 走势图
    getTrend = () => {
        let { item } = this.props;
        let { searchParams } = this.state;

        this.setState({
            trendLoading: true
        });
        statisticReportTrend({ ...searchParams, companyCode: item.companyCode }).then(data => {
            this.trendData = data || [];
            this.setState({
                lineOption: formatComTrendOption(this.getCurrentTrendData())
            });
        }).finally(() => {
            this.setState({
                trendLoading: false
            });
        });
    };

    getCurrentTrendData = () => {
        let { selectedSubAnaType } = this.state;
        let currentData = this.trendData.find(d => Number(d.key) === Number(selectedSubAnaType.key)) || {};
        return currentData.data || (this.trendData[0] && this.trendData[0].data) || [];
    };

    // 改变财二级报类型
    changeSubAnaType = selectedSubAnaType => {
        this.setState({
            selectedSubAnaType
        }, () => {
            this.setState({
                lineOption: formatComTrendOption(this.getCurrentTrendData())
            });
        });
    };

    getPopupContainer = () => {
        return document.querySelector(`.${styles.modalWrap}`);
    };

    render() {
        const { visible, onCancel, options, item } = this.props;
        const { radarOption, lineOption, scoreLoading, trendLoading, selectedSubAnaType, compositeScore, subAnaType } = this.state;
        let tagStyle = { width: `${1 / subAnaType.length * 100}%` };

        return (
            <Modal
                wrapClassName={styles.modalWrap}
                width={900}
                onCancel={onCancel}
                visible={visible}
                footer={null}
            >
                <GroupBox title="分析概览">

                    <BaseInfo item={item}/>

                    <SearchForm options={options} item={item} getPopupContainer={this.getPopupContainer} onSearch={this.onSearch}/>

                    <div className={styles.gradeBox}>
                        {
                            scoreLoading ?
                                <Spin/> :
                                <div>
                                    <div className={styles.grade}><i className="iconfont icon-pen"></i> 综合评分：{fieldAnomaly(compositeScore)}</div>
                                    <div className={styles.chart}>
                                        {
                                            isNotEmpty(radarOption) ?
                                                <BBDRadar option={radarOption} /> :
                                                <NoData />
                                        }
                                    </div>
                                </div>
                        }
                    </div>

                    <div className={classNames(styles.tags, 'clearfix')}>
                        {subAnaType && subAnaType.map(d => {
                            let isActive = d.key === selectedSubAnaType.key;
                            return (
                                <a
                                    key={d.key}
                                    href="javascript:void(0)"
                                    style={tagStyle}
                                    className={classNames({ [styles.tagActive]: isActive })}
                                    onClick={isActive ? undefined : () => this.changeSubAnaType(d)}
                                >
                                    {d.value}
                                </a>
                            );
                        })}
                    </div>
                    <div className="wrap-title">
                        综合能力走势 <span className={styles.titleTip}><i className="iconfont icon-shuoming"> </i>该能力得分越高，说明风险越高。</span>
                    </div>
                    <div className={styles.chart}>
                        {
                            trendLoading ?
                                <Spin /> :
                                isNotEmpty(lineOption) ?
                                    <BBDLineBar option={lineOption} /> :
                                    <NoData />
                        }
                    </div>
                </GroupBox>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/company/OverviewModal.jsx